import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";

export class InviteCRMUserForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});

        let submit_url = this.urlForSubmit();
        const postData = {
            'email': event.target.email.value,
            'client_id': this.props.clientId
        };

        new APIClient(submit_url).call('POST', postData).then((data) => {
            this.setState({saving: false});
            if (data.status === 'ERROR_CRM_USER_ALREADY_EXISTS') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.props.afterSubmit()
            }
        })
    }

    urlForSubmit() {
        return API_URL + 'crm/users/invite';
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>Email address</label>
                            <input name="email" type="text"/>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }

    renderSaveButton() {
        if (!this.state.saving) {
            return <input type="submit" value="Enviar" className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

}
